export * from './card.variants.defaults';
